import { BSpinner, BText, BTitle } from '@prague-digi/ui-components'
import { compose } from 'redux'
import { connect } from 'react-redux'
import React, { useEffect, Fragment } from 'react'

import { popActions } from '../../redux'
import { intl, IntlInterface, wizard, WizardInterface } from '../../hoc'

import messages from '../../i18n'

type Props = IntlInterface & WizardInterface & typeof mapDispatchToProps

export const PopProcessing = ({ processingSetup, translate, translateHTML, wizard }: Props) => {
  useEffect(() => {
    processingSetup(wizard.gotoNext)
  }, [processingSetup, wizard.gotoNext])

  return (
    <Fragment>
      <BTitle center type="h3">
        {translate(messages.popProcessing.title)}
      </BTitle>
      <BText center type="secondary">
        {translateHTML(messages.popProcessing.text)}
      </BText>
      <BSpinner isShown isStatic style={{ zIndex: 0 }} />
    </Fragment>
  )
}

const mapDispatchToProps = {
  processingSetup: popActions.processingSetup,
}

export default compose(intl, wizard, connect(null, mapDispatchToProps))(PopProcessing)
